import { FeatureFlags } from 'domains/Brazil/commons/types/FeatureFlags.enum';
import { PaymentMethod } from 'domains/Brazil/commons/types/PaymentMethod.enum';
import { SettlementPeriod } from 'domains/Brazil/commons/types/SettlementPeriod.enum';

export interface StoreConfigurations {
  id: number;
  regionalPaymentGatewayId: string;
  name: string;
  url: string;
  category: string;
  active: boolean;
  owner: Owner;
  preferences: Preferences;
  status: string;
  kycStatus: string;
  contacts: Contact[];
  flags: FeatureFlags[];
  fraudEngines: FraudEngine[];
  createdAt: string;
  updatedAt: string;
  concessionId: string;
  installationStatus: InstallationStatusEnum;
}

export enum InstallationStatusEnum {
  INSTALLED = 'INSTALLED',
  PROCESSING_INSTALLATION = 'PROCESSING_INSTALLATION',
  PENDING_INSTALLATION = 'PENDING_INSTALLATION',
}

export enum KycStatusEnum {
  NOT_STARTED = 'not_started',
  STARTED = 'started',
  COMPLETED = 'completed',
  FAILED = 'failed',
  BLOCKED = 'blocked',
}

export interface Owner {
  name: string;
  email: string;
  document: string;
  country: string;
}

export interface Preferences {
  planId: number;
  settlementPeriod: SettlementPeriod;
  previousEligiblePlanInstallments: any[];
  eligiblePlanInstallments: any[];
  previousActivePlanInstallments: PreviousActivePlanInstallment[];
  activePlanInstallments: ActivePlanInstallment[];
  changingResponsible: boolean;
  maxInstallments: number;
  maxInstallmentsWithoutInterest: number;
  minInstallmentValue: MinInstallmentValue;
  activePaymentMethods: PaymentMethod[];
  enabledPaymentMethods: EnabledPaymentMethod[];
  statementDescriptor: string;
  tierClassification: string;
  discounts: Discount[];
  settlementFees: SettlementFees;
  isFreemium: boolean;
}

export interface ActivePlanInstallment {
  installmentNumber: number;
  type: string;
  responsible: string;
  interestFee?: number;
}

export interface MinInstallmentValue {
  currency: string;
  value: number;
}

export interface EnabledPaymentMethod {
  type: string;
  expirationTime?: number;
  notifyExpiration?: boolean;
}

export interface Contact {
  id: number;
  email: string;
  createdAt: string;
  updatedAt: string;
}

export interface FraudEngine {
  provider: string;
  accountId: string;
  active: boolean;
  createdAt: string;
}

export interface BankAccount {
  fiscalDocument?: string;
  bankName?: string;
  bankCode?: string;
  accountNumber?: string;
  holderName?: string;
  holderDocument?: string;
  accountCheckDigit?: string;
  branchNumber?: string;
  branchCheckDigit?: string;
}

export interface Discount {
  paymentMethodType: PaymentMethod;
  percentage: number;
  allowDiscountCombination: boolean;
}
export interface SettlementFees {
  boleto: SettlementFeesConfiguration[];
  pix: SettlementFeesConfiguration[];
  creditCard: SettlementFeesConfiguration[];
}

export interface SettlementFeesConfiguration {
  settlementPeriod: number;
  interestFee: number;
  fee: number;
  isNoAnticipationPlan?: boolean;
}

export interface PreviousActivePlanInstallment {
  type: string;
  interestFee: number;
  responsible: string;
  installmentNumber: number;
}

export type FetchProviderSettingsType = () => Promise<StoreConfigurations>;
